import { render, staticRenderFns } from "./edit-profile.vue?vue&type=template&id=6feac30e&scoped=true&"
import script from "./edit-profile.vue?vue&type=script&lang=js&"
export * from "./edit-profile.vue?vue&type=script&lang=js&"
import style0 from "./edit-profile.vue?vue&type=style&index=0&id=6feac30e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feac30e",
  null
  
)

export default component.exports